import * as React from 'react';
import { Field } from 'components/Form/Field';
import { FieldSet } from 'components/Elements/FieldSet';
import Loader from 'components/Loader';
import { submitForm as submitFormAction } from 'app/actions/formActions';
import {
	formFieldsSelector,
	formValuesSelector,
} from 'app/selectors/formSelector';
import { useFormValidator } from 'utils/useFormValidator';
import submitForm from 'utils/submitForm';
import { ReactElement, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';

interface FormProps {
	children: ReactElement;
	disabled?: boolean;
	ownFields?: any[];
	section: string;
	stage: string;
	onSubmit?: (section, stage, values, nopersist) => void;
	submitAction?: () => void;
	className?: string;
	hardSubmit?: boolean;
}

export const Form = ({
	children,
	disabled = false,
	ownFields = [],
	section,
	stage,
	onSubmit,
	submitAction,
	className = '',
	hardSubmit = false,
}: FormProps) => {
	const dispatch = useAppDispatch();
	const fieldsetValidator = useFormValidator();
	const formFieldsStatus = useAppSelector(
		(state) => state.forms.formFieldsStatus,
	);
	const errors = useAppSelector((state) => state.errors.errors);
	const nopersist = useAppSelector((state) => state.nopersist);
	const formFields = useAppSelector((state) =>
		formFieldsSelector(state, { section, stage }),
	);
	const values = useAppSelector((state) =>
		formValuesSelector(state, { section, stage }),
	);
	const fields: any[] = ownFields ? [] : formFields;

	useEffect(() => {
		if (errors) {
			fieldsetValidator.update(errors);
		}
		// TODO: test and update
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [errors]);

	const renderConfigFields = () => {
		if (formFieldsStatus === 'loading') {
			return <Loader small />;
		}

		return fields.map((field, index) => {
			return (
				<Field
					{...field}
					disabled={disabled}
					section={section}
					stage={stage}
					key={`field-${index}`}
				/>
			);
		});
	};

	const renderFields = () => {
		if (!ownFields || !ownFields.length) {
			return renderConfigFields();
		}

		return ownFields;
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (fieldsetValidator.isValid()) {
			if (onSubmit && typeof onSubmit === 'function') {
				onSubmit(section, stage, values, nopersist);
			} else if (submitAction && typeof submitAction === 'function') {
				submitForm(section, stage, values, nopersist, submitAction);
			} else {
				// @ts-expect-error TS(2554): Expected 0-3 arguments, but got 4.
				dispatch(submitFormAction(section, stage, values, nopersist));
			}
		}
	};

	const hasFields = Boolean(
		(ownFields && ownFields.length) || (fields && fields.length),
	);

	return (
		<form
			autoComplete="off"
			noValidate
			method="post"
			name={`${section}_${stage}`}
			action={`${section}/${stage}`}
			className={className}
			onSubmit={hardSubmit ? undefined : handleSubmit}
		>
			{/* @ts-expect-error TS(2339): Property '_csrf_token' does not exist on type 'Win... Remove this comment to see the full error message */}
			{hardSubmit && window._csrf_token ? (
				<>
					{/* @ts-expect-error TS(2339): Property '_csrf_token' does not exist on type 'Win... Remove this comment to see the full error message */}
					<input type="hidden" name="_token" value={window._csrf_token} />
				</>
			) : (
				<></>
			)}
			{hasFields && <FieldSet>{renderFields()}</FieldSet>}
			{children}
		</form>
	);
};
